export const GAME_WIDTH = 640;
export const GAME_HEIGHT = 360;
/** Canvas pixels per logical pixel; see systems/RenderScale.ts. */
export const RENDER_SCALE = 2;
/** Matches Mega.MapBuilder default tile size 1:1. */
export const TILE_SIZE = 32;
export const PLAYER_SPEED = 150;
export const INTERACT_RANGE = 52;

export const SAVE_STORAGE_KEY = 'pancake.save.v1';
/** Last save this build couldn't read, kept before it gets overwritten. */
export const SAVE_BACKUP_KEY = 'pancake.save.v1.backup';
/** Multi-adventure index. The v1 key is deliberately retained for recovery. */
export const SAVE_SLOTS_STORAGE_KEY = 'pancake.save-slots.v1';
export const SAVE_SLOT_STORAGE_PREFIX = 'pancake.save-slot.v1.';
export const SETTINGS_STORAGE_KEY = 'pancake.settings.v1';

export const IS_DEV =
  typeof import.meta !== 'undefined' &&
  typeof import.meta.env !== 'undefined' &&
  Boolean(import.meta.env.DEV);
